import { gql } from '@apollo/client';

export const CREATE_LEADERSHIP_POST = gql`
    mutation CreateLeadershipPost($title: String!, $description: String!, $type: String!) {
        createLeadershipPost(title: $title, description: $description, type: $type) {
            ... on LeadershipUpdate {
                id
                title
                description
                type
            }
            ... on LeadershipPrayerRequest {
                id
                title
                description
                type
            }
        }
    }
`;
